import type { FlowCapabilities } from './types';

// Aviso tras firmar la aprobación (G2-D punto 6). Se arma con el estado del flujo que
// devuelve el servidor DESPUÉS de la firma: una persona puede cubrir varios cupos (su
// usuario y su puesto), así que la app no puede calcular sola cuántas firmas faltan.

type AfterSign = Pick<FlowCapabilities, 'lockedAt' | 'stage' | 'currentStatus' | 'flowInstanceId'>;

export function approvalToast(after: AfterSign | null): string {
  if (after === null) {
    return 'Firma registrada';
  }
  // La última firma con la vigencia de hoy o pasada activa en el acto y cierra el flujo:
  // la relectura trae el documento vigente, sin flujo activo.
  if (after.currentStatus === 'vigente' && after.flowInstanceId === null) {
    return 'Documento firmado, aprobado y vigente';
  }
  if (after.lockedAt !== null) {
    return 'Documento firmado y aprobado';
  }
  const pending = after.stage?.slots.filter((s) => s.status === 'pending').length ?? 0;
  if (pending === 0) {
    return 'Firma registrada: Calidad completa la aprobación';
  }
  return pending === 1
    ? 'Firma registrada: falta 1 firma'
    : `Firma registrada: faltan ${pending} firmas`;
}
